const failure = message => Object.assign(new Error(message), { code:'PIECE_SOURCE_REQUIRED' });

export function approvedPieceSourceRefs(content) {
  const used=content?.used_source_ids || content?.usedSourceIds || [];
  const selected=content?.audit?.context?.selected || [];
  if (!Array.isArray(used) || !used.length) throw failure('Esta peça não registra uma fonte usada. Mantenha-a como rascunho.');
  const refs=[];
  for (const id of [...new Set(used)]) {
    const source=selected.find(item=>item.sourceId===id);
    if (!source || source.status!=='approved') throw failure('Uma fonte usada pela peça ainda não está aprovada ou vigente. Revise as fontes antes do aceite.');
    if (!id.startsWith('document:drive:') || !/^[a-f0-9]{64}$/i.test(source.hash||'')) throw failure('Esta fonte ainda não tem aprovação verificável no registro editorial. Mantenha a peça como rascunho.');
    refs.push({sourceId:id.slice('document:'.length),sha256:source.hash});
  }
  return refs;
}
